import PropTypes from "prop-types";

const CardDashboard = (props) => {
  return (
    <div
      className={`relative mt-3 border border-primary shadow-lg rounded-lg px-2 md:px-4 py-3 ${props.className}`}
    >
      <div className=" absolute -top-3 bg-primary text-white px-2.5 py-1 rounded-lg shadow-lg">
        <div className="flex items-center space-x-1.5">
          <div>{props.icon}</div>
          <div className="text-base">{props.title}</div>
        </div>
      </div>
      <div className="mt-2">{props.children}</div>
    </div>
  );
};

CardDashboard.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  icon: PropTypes.element,
};
export default CardDashboard;
